<template>
  <div v-if="backdrop">
    <div
      class="modal fade"
      :class="modal.open ? 'show' : ''"
      style="display: block"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      @click="$event.target.classList.contains('modal') ? close() : true"
    >
      <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width : 800px" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{config.title == null ? '&nbsp;' : config.title}}</h5>
            <button type="button" class="close" @click="close()" v-html="request ? spin() : ic('close')"/>
          </div>
          <div class="modal-body">
            <div class="card-tabs mb-0">
              <ul class="nav nav-tabs">
                <li class="nav-item" v-for="(tab, i) in ['Harga Barang','Riwayat Harga Barang']" :key="i" @click="tabActive = i">
                  <a class="nav-link" :class="tabActive == i ? 'active' : ''" data-toggle="tab" v-html="tab"></a>
                </li>
              </ul>
              <div class="tab-content">
                <div class="card tab-pane" :class="tabActive == 0 ? ' active show' : ''">
                  <div class="card-body">
                    <form @submit.prevent="updateHarga">
                      <Skeleton 
                        v-if="request" 
                        type="table" 
                        :length="total_tipe_harga" 
                        :column="2" 
                      />
                      <section id="section-form" v-else>
                        <div class="col-sm-12">
                          <div class="form-group">
                            <label class="form-label">Default PPN Value</label>
                            <input 
                              class="form-control"
                              v-model="data.default_ppn"
                              @input="_setGlobalPPN"
                              type="number" :readonly="!isCanPpn" 
                              placeholder="Inputkan default ppn value">
                          </div>
                        </div>

                        <section id="modal-body">
                          <div class="row" id="title-harga">
                            <div class="col-sm-5">
                              <label class="form-label">
                                Harga Exclude
                                <a type="button" @click="isCanExclude = isCanExclude ? false : true ">
                                  <i class="ml-2 fa fa-lock"></i>
                                </a>
                              </label>
                            </div>
                            <div class="col-sm-2">
                              <label class="form-label">PPN 
                                <a type="button" @click="isCanPpn = isCanPpn ? false : true ">
                                  <i class="ml-2 fa fa-lock"></i>
                                </a>
                              </label>
                            </div>
                            <div class="col-sm-5">
                              <label class="form-label">Harga Include</label>
                            </div>
                          </div>
                          <div class="row mb-3" v-for="(harga, index) in data.harga_barang">
                            <div class="mb-1">
                              Harga pada tanggal: <strong>{{harga.created_at}}</strong>
                            </div>
                            
                            <div class="col-sm-5 d-flex">
                              <span 
                                class="input-group-text text-start capitalize custom-input-group-text" 
                                style="font-size: 12px; width: 85%;" 
                                v-html='`${harga.tipe_harga}`'>
                              </span>
                              <currency-input
                                class="form-control custom-form-control"
                                :precision=2
                                :readonly="!isCanExclude"
                                @change="_setHarga(harga)"
                                :placeholder="'Inputkan harga tanpa ppn '+harga.tipe_harga"
                                v-model="harga.harga_non_ppn"
                              />
                            </div>
                            <div class="col-sm-2">
                              <input type="number" 
                                class="form-control h-full" 
                                @input="_setHarga(harga)"
                                :readonly="!isCanPpn"
                                v-model="harga.ppn"
                              >
                            </div>
                            <div class="col-sm-5 d-flex">
                              <span 
                                class="input-group-text capitalize custom-input-group-text" 
                                style="font-size: 12px; width: 85%;" 
                                v-html="harga.tipe_harga">
                              </span>
                              <currency-input
                                :precision=2
                                type="tel"
                                class="form-control custom-form-control"
                                @change="_setHargaExclude(harga)"
                                :placeholder="'Inputkan harga '+harga.tipe_harga"
                                v-model="harga.harga"
                              />
                            </div>
                          </div>
                        </section>
                      </section>

                      <section class="d-flex justify-content-end">
                        <button
                          type="submit"
                          class="btn btn-primary mt-2 w-full"
                          :disabled="isSubmit || request"
                          v-html="isSubmit ? spin() : 'Simpan'"
                        />
                      </section>
                    </form>
                  </div>
                </div>
                <div class="card tab-pane" :class="tabActive == 1 ? ' active show' : ''">
                  <div class="card-body ">
                    <table class="table table-bordered table-striped ">
                      <thead>
                        <tr>
                          <th class="text-center">No</th>
                          <th class="text-center">Tipe Harga</th>
                          <th class="text-center">Harga Exclude</th>
                          <th class="text-center">PPN</th>
                          <th class="text-center">Harga</th>
                          <th class="text-center">Tanggal Berlaku</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(harga, index) in data.harga_barang_history">
                          <tr>
                            <td colspan="6">
                              Dibuat Oleh: {{harga.created_by}}
                            </td>
                          </tr>
                          <tr>
                            <td class="text-center">{{index+1}}</td>
                            <td class="text-center">{{harga.tipe_harga}}</td>
                            <td class="text-center">Rp.{{ribuan(harga.harga_non_ppn)}}</td>
                            <td class="text-center">{{harga.ppn}}%</td>
                            <td class="text-center">Rp. {{ribuan(harga.harga)}}</td>
                            <td class="text-center">{{dFormat(harga.tanggal_efektif, 'dMY')}}</td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import {mapActions} from "vuex";

export default {
  name: "FormHargaBarang",
  props: {
    config: {
      default: {
        view: false,
        title: "Form Harga Barang"
      }
    },
    initData: null,
    isSubmit: {default: false},
  },

  mixins: [helper],

  data() {
    return {
      backdrop: false,
      modal: {
        open: false,
      },

      initHargaBarang: [],

      data:{
        barang: {},
        harga_barang: [],
        harga_barang_history: [],
        tipe_harga: [],
        default_ppn: 0
      },

      tabActive: 0,
      isCanExclude : false,
      isCanPpn : false,
      request: false, 
    };
  },
  computed:{
    total_tipe_harga(){
      return this.data.tipe_harga.length
    }
  },
  methods: {
    ...mapActions('barang', ['hargaBarangById','getHargaBarangHistoryById']),

    updateHarga(){
      const payloadUpdate = this.data.harga_barang.filter((harga_barang, index) => {
        const hargaOld = this.initHargaBarang.find(item => item.tipe_harga == harga_barang.tipe_harga);
        return hargaOld && harga_barang.harga !== hargaOld.harga;
      })
      if (payloadUpdate.length > 0) {
        this.submit(payloadUpdate)
      }
    },

    _setHarga(data){
      data.ppn = Number(data.ppn)
      if (isNaN(data.ppn)) {
        data.ppn = 0
      }
      data.ppn_value = parseFloat(data.harga_non_ppn) * parseFloat(data.ppn) / 100
      data.harga = parseFloat(data.ppn_value) + parseFloat(data.harga_non_ppn)
    },

    _setHargaExclude(data){
      data.harga_non_ppn = parseFloat(data.harga) / ((parseFloat(data.ppn) + 100) / 100)
      data.ppn_value =  parseFloat(data.harga) - parseFloat(data.harga_non_ppn)
    },

    _setGlobalPPN(){
      if (Number(this.data.default_ppn) >= 0) {
        this.data.harga_barang.forEach((harga_barang) => {
          harga_barang.ppn = this.data.default_ppn
          this._setHarga(harga_barang)
        }) 
      }
    },

    getDefaultPPn(){
      const countPPn = this.data.harga_barang.filter(item => item.ppn > 0).length 
      const sumPPN = this.data.harga_barang.reduce((total, item) => {
        return total + item.ppn;
      }, 0);
      if(countPPn == 0){
        this.data.default_ppn = 0
        return
      }
      this.data.default_ppn = sumPPN/countPPn;
    },

    async getTipeHargaBarang(){
      const response = await this.axios.get('tipe_harga', {
        params: {
          id_perusahaan: this.data.barang.id_perusahaan
        }
      })
      return response.data.data
    },

    async getHargaBarang(){
      this.data.harga_barang = []
      this.data.tipe_harga = []
      this.request = true;
      try {
        this.data.tipe_harga = await this.getTipeHargaBarang()
        const hargaBarang = await this.hargaBarangById(this.data.barang.id)
        this.data.tipe_harga.forEach((tipeHarga) => {
          const barangByTipeHarga = hargaBarang.find(item => item.tipe_harga === tipeHarga.tipe_harga.toLowerCase());
          let harga = {
            id_barang : this.data.barang.id,
            tipe_harga : tipeHarga.tipe_harga,
            harga : 0,
            ppn : 0,
            ppn_value : 0,
            harga_non_ppn : 0,
            created_at : '',
          }
          if(barangByTipeHarga){
            harga.harga = barangByTipeHarga.harga
            harga.ppn = barangByTipeHarga.ppn
            harga.ppn_value = barangByTipeHarga.ppn_value
            harga.harga_non_ppn = barangByTipeHarga.harga_non_ppn
            harga.created_at = barangByTipeHarga.created_at
          }
          this.data.harga_barang.unshift(harga)
          this.initHargaBarang.unshift({...harga}) // Use spread operator to create a copy
        });
        this.getDefaultPPn()
      } catch (error) {
        this.onError(error)
      } finally {
        this.request = false;
      }
    },

    async getHargaBarangHistory(){
      this.request = true;
      try {
        const res = await this.getHargaBarangHistoryById(this.data.barang.id)
        this.data.harga_barang_history = res.data
      } catch (error) {
        this.onError(error)
      } finally {
        this.request = false;
      }
    },

    submit() {
      this.$emit('update:isSubmit', true)
      this.$emit('submit', this.data.harga_barang);
    },
    close() {
      this.$emit("update:config", { view: false });
    },
  },

  watch: {
    "config.view": function(view) {
      if (view) {
        this.backdrop = true;
        const barang = this.data.barang
        if(!barang || barang.id != this.initData.id){
          this.data.barang = this.initData
          this.getHargaBarang()
        }
        this.isCanExclude = false
        this.isCanPpn = false
        this.getHargaBarangHistory()
        this.$emit("update:isSubmit", false);
        setTimeout(() => {
          this.modal.open = view;
        }, 100);
      } else {
        this.modal.open = view;
        setTimeout(() => {
          this.backdrop = view;
        }, 100);
      }
    },
  }
};
</script>

<style lang="scss" scoped src="./harga-barang.scss" />
